import css from "styled-jsx/css";

export default css`
  .social-media-icon {
    .regular-icon-container {
      display: block;
    }
    .colorful-icon-container {
      display: none;
    }
    &:hover {
      .regular-icon-container:not(.force-display) {
        display: none;
      }
      .colorful-icon-container {
        display: block;
      }
    }
  }
`;
